import cx from 'classnames';
import { FunctionComponent, useRef } from 'react';

import BPartsBicon from '../icons/bparts-b-icon';

const LoadingIcon: FunctionComponent<{
  isCenter?: boolean
  // Overlay backdrop. Defaults to the app-wide dimmed drop; pass e.g.
  // 'bg-transparent' to blend with the parent background (no colour difference).
  bgClassName?: string
}> = ({ isCenter = false, bgClassName = 'bg-generic-loading-drop'
}) => {

    return (
      <div
        className={cx(
          'h-full w-full flex items-center justify-center flex-col',
          'fixed top-0 left-0 z-50',
          bgClassName
        )}
      >
        <BPartsBicon
          className={cx(
            'w-20 h-20 animate-bounce',
            'opacity-85',
          )}
        />
      </div>
    );
  };

export default LoadingIcon;
